import { Risk } from "../types/types"

type RiskAction = {
  type: string
  risk: Risk
}
export const risksReducer = (risks: Risk[], action: RiskAction) => {
  switch (action.type) {
    case "PUSH": {
      const risk = action.risk
      const riskIndex = risks.findIndex((r) => r.id === risk.id)
      if (riskIndex !== -1) {
        const newRisks = [...risks]
        newRisks[riskIndex] = risk
        return newRisks
      } else {
        return [...risks, risk]
      }
    }
    default:
      return risks
  }
}
